module.exports = " <div class=pop-select-dropdown :style=styles><slot></slot></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/multi-category/dropdown.vue
// module id = 303
// module chunks = 0